const swalModal = swal.mixin({
    reverseButtons: false,
    buttonsStyling: false,
    showCloseButton: true,
    cancelButtonText: "Annuller",
    position: 'top',
    showClass: {
        popup: 'fadeInDown'
    },
    hideClass: {
        popup: 'fadeOutUp'
    },
    customClass: {
        popup: 'modal-content modal-md p-0',
        header: 'modal-header bg-light',
        title: 'modal-title',
        closeButton: 'close',
        content: 'modal-body text-left',
        input: 'w-100',
        inputLabel: 'justify-content-start',
        actions: 'modal-footer border-top-0',
        confirmButton: 'btn btn-outline-primary m-1',
        denyButton: 'btn btn-secondary m-1',
        cancelButton: 'btn btn-outline-secondary m-1'
    }
});